import React, { useState, useEffect } from "react";
import { FaRupeeSign } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Propertylist = () => {
  const navigate = useNavigate();
  const [propertyData, setPropertyData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  console.log("propertyData===", propertyData)

  useEffect(() => {
    setIsLoading(true);
    fetch(process.env.REACT_APP_GET_PROPERTIES_LIST)
      .then((response) => response.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setPropertyData(data);
        } else {
          console.error("Expected an array but got:", data);
          setPropertyData([]);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching property data:", error);
        setError(error.message);
        setError(navigate('/ErrorMessage'));
        setIsLoading(false);
      });
  }, []);


  const handlePropertyClick = (property) => {
    navigate(`/property-details/${property.property_id}`, { state: { property } });
  };

  // if (isLoading) {
  //   return <div className="section-featured tf-spacing-1 p-2">
  //     Loading properties...
  //     </div>;
  // }

  if (error) {
    return (
      <div className="section-featured tf-spacing-1 p-2">
        <div className="alert alert-danger">Error loading properties: {error}</div>
      </div>
    );
  }

  const PropertySkeleton = ({ layout = "grid" }) => {
    if (layout === "list") {
      return (
        <div className="list-layout-skeleton">
          <div className="list-image-skeleton skeleton-loader"></div>
          <div className="list-content-skeleton">
            <div className="property-title-skeleton skeleton-loader"></div>
            <div className="property-location-skeleton skeleton-loader"></div>
            <div className="property-meta-skeleton">
              <div className="meta-item-skeleton skeleton-loader"></div>
              <div className="meta-item-skeleton skeleton-loader"></div>
            </div>
            <div className="list-bot-skeleton">
              <div className="property-price-skeleton skeleton-loader"></div>
              <div className="property-btn-skeleton skeleton-loader"></div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="property-card-skeleton">
        <div className="property-image-skeleton skeleton-loader"></div>
        <div className="property-content-skeleton">
          <div className="property-title-skeleton skeleton-loader"></div>
          <div className="property-location-skeleton skeleton-loader"></div>
          <div className="property-meta-skeleton">
            <div className="meta-item-skeleton skeleton-loader"></div>
            <div className="meta-item-skeleton skeleton-loader"></div>
          </div>
          <div className="property-price-skeleton skeleton-loader"></div>
          <div className="property-btn-skeleton skeleton-loader"></div>
        </div>
      </div>
    );
  };

  return (
    <section className="flat-title style-2">
      <div className="main-content">
        <section className="section-property-layout">
          <div className="tf-container">
            <div className="row">
              <div className="col-12">
                <div className="box-title">
                  <h2 className="mt-3">Our Properties</h2>
                </div>
                <div className="tab-content">
                  <div id="listLayout" className="tab-pane active">
                    <div className="tab-paneactive show" id="listLayout-sub" role="tabpanel">
                      {isLoading ? (
                        <div className="tf-grid-layout lg-col-2">
                          {/* Render multiple skeleton loaders based on your layout */}
                          {[...Array(2)].map((_, index) => (
                            <PropertySkeleton key={index} />
                          ))}
                        </div>

                      ) : (
                        <div className="tf-grid-layout lg-col-2">
                          {propertyData.length > 0 ? (
                            propertyData.map((property, index) => (
                              <div
                                key={index}
                                className="box-house style-list hover-img"
                              >
                                <div className="image-wrap">
                                  {property.property_images &&
                                    property.property_images.length > 0 ? (
                                    <img
                                      className="lazyload"
                                      loading="lazy"
                                      src={property.property_images[0].src}
                                      alt={property.property_images[0].title}
                                    />
                                  ) : null}
                                </div>
                                <div className="content">
                                  <h5 className="title">
                                    <span>{property.property_name}</span>
                                  </h5>
                                  <div className="location text-1 line-clamp-1">
                                    <div className={`icons  ${property?.icon}`} />
                                  </div>
                                  <ul className="meta-list flex cos-custom">
                                    <li className="meta-item">
                                      <div className="text-9 flex">
                                        {property?.property_details[0].label}
                                      </div>
                                      <div className="text-9 flex">
                                        <span>{property?.property_details[0].value}</span>
                                      </div>
                                    </li>
                                    <li className="meta-item">
                                      <div className="text-9 flex">
                                        {property?.property_details[2].label}
                                      </div>
                                      <div className="text-9 flex">
                                        <span>{property?.property_details[2].value}</span>
                                      </div>
                                    </li>
                                  </ul>
                                  <div className="bot flex justify-between items-center">
                                    <h5 className="price">
                                      COS Value: <span><FaRupeeSign /></span>
                                      {property?.fraction_details[4].value}
                                    </h5>
                                    <div className="wrap-btn flex">
                                      <button
                                        className="tf-btn style-border pd-4"
                                        onClick={() => handlePropertyClick(property)}
                                      >
                                        Details
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))
                          ) : (
                            <p>No properties found.</p>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  );
};

export default Propertylist;




// import React, { useState } from 'react';
// import boxhouse from '../../Assests/images/section/box-house.jpg';
// import boxhouse2 from '../../Assests/images/section/box-house-2.jpg';
// import boxhouse3 from '../../Assests/images/section/box-house-3.jpg';
// import boxhouse4 from '../../Assests/images/section/box-house-4.jpg';
// import boxhouse5 from '../../Assests/images/section/box-house-5.jpg';
// import boxhouse6 from '../../Assests/images/section/box-house-6.jpg';
// import { TbGridDots } from "react-icons/tb";
// import { AiOutlineUnorderedList } from "react-icons/ai";

// const TopsearchCards = () => {
//     const [activeTab, setActiveTab] = useState('grid');

//     const handleTabClick = (tab) => {
//         setActiveTab(tab);
//     };

//     return (
//         <div className="main-content">
//             <section className="section-property-layout">
//                 <div className="tf-container">
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="box-title">
//                                 <h2>Property listing</h2>
//                                 <div className="right">
//                                     <ul className="nav-tab-filter group-layout" role="tablist">
//                                         <li className="nav-tab-item" role="presentation">
//                                             <span
//                                                 className={`btn-layout grid nav-link-item ${activeTab === 'grid' ? 'active' : ''}`}
//                                                 onClick={() => handleTabClick('grid')}
//                                             >
//                                                 <TbGridDots style={{ width: '25px', height: '25px', color: 'gray' }} className='svg-color' />
//                                             </span>
//                                         </li>
//                                         <li className="nav-tab-item" role="presentation">
//                                             <span className={`btn-layout list nav-link-item ${activeTab === 'list' ? 'active' : ''}`}
//                                                 onClick={() => handleTabClick('list')}
//                                             >
//                                                 <AiOutlineUnorderedList
//                                                     style={{ width: '25px', height: '25px', color: 'gray' }}
//                                                     className='svg-color'
//                                                 />
//                                             </span>
//                                         </li>
//                                     </ul>
//                                 </div>
//                             </div>
//                             <div className="tab-content">
//                                 {activeTab === 'grid' && (
//                                     <div id="gridLayout" className="tab-pane active">
//                                         <div className="tab-pane " id="gridLayout" role="tabpanel">
//                                             <div className="tf-grid-layout lg-col-3 md-col-2">
//                                                 <div className="box-house hover-img">
//                                                     <div className="image-wrap">
//                                                         <img className="lazyload" data-src={boxhouse}
//                                                             src={boxhouse} alt="" />
//                                                         <ul className="box-tag flex gap-8 ">
//                                                             <li className="flat-tag text-4 bg-main fw-6 text-white">Featured
//                                                             </li>
//                                                             <li className="flat-tag text-4 bg-3 fw-6 text-white">For Sale</li>
//                                                         </ul>
//                                                         <div className="list-btn flex gap-8 ">
//                                                             <span className="btn-icon save hover-tooltip"><i
//                                                                 className="icon-save"></i>
//                                                                 <span className="tooltip">Add Favorite</span>
//                                                             </span>
//                                                             <span className="btn-icon find hover-tooltip"><i
//                                                                 className="icon-find-plus"></i>
//                                                                 <span className="tooltip">Quick View</span>
//                                                             </span>
//                                                         </div>
//                                                     </div>
//                                                     <div className="content">
//                                                         <h5 className="title">
//                                                             <span>Elegant studio flat</span>
//                                                         </h5>
//                                                         <p className="location text-1 line-clamp-1 ">
//                                                             <i className="icon-location"></i> Medavakkam, Chennai - 600100
//                                                         </p>
//                                                         <ul className="meta-list flex cos-custom">
//                                                             <li className="meta-item"><div className="text-9 flex">Property Type</div><div className="text-9 flex"><span>Plot Land</span></div></li>
//                                                             <li className="meta-item"><div className="text-9 flex">Property Size</div><div className="text-9 flex"><span>2400 Sq.ft</span></div></li>
//                                                         </ul>
//                                                         <div className="bot flex justify-between items-center">
//                                                             <h5 className="price">
//                                                                 COS Value: INR 5,00,000
//                                                             </h5>
//                                                             <div className="wrap-btn flex">
//                                                                 <a href="/Property-details"
//                                                                     className="tf-btn style-border pd-4">Details</a>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="box-house hover-img">
//                                                     <div className="image-wrap">
//                                                         <img className="lazyload" data-src={boxhouse2}
//                                                             src={boxhouse2} alt="" />
//                                                         <ul className="box-tag flex gap-8 ">
//                                                             <li className="flat-tag text-4 bg-main fw-6 text-white">Featured
//                                                             </li>
//                                                             <li className="flat-tag text-4 bg-3 fw-6 text-white">For Sale</li>
//                                                         </ul>
//                                                         <div className="list-btn flex gap-8 ">
//                                                             <span className="btn-icon save hover-tooltip"><i
//                                                                 className="icon-save"></i>
//                                                                 <span className="tooltip">Add Favorite</span>
//                                                             </span>
//                                                             <span className="btn-icon find hover-tooltip"><i
//                                                                 className="icon-find-plus"></i>
//                                                                 <span className="tooltip">Quick View</span>
//                                                             </span>
//                                                         </div>
//                                                     </div>
//                                                     <div className="content">
//                                                         <h5 className="title">
//                                                             <span>Elegant studio flat</span>
//                                                         </h5>
//                                                         <p className="location text-1 line-clamp-1 ">
//                                                             <i className="icon-location"></i> Medavakkam, Chennai - 600100
//                                                         </p>
//                                                         <ul className="meta-list flex cos-custom">
//                                                             <li className="meta-item"><div className="text-9 flex">Property Type</div><div className="text-9 flex"><span>Plot Land</span></div></li>
//                                                             <li className="meta-item"><div className="text-9 flex">Property Size</div><div className="text-9 flex"><span>2400 Sq.ft</span></div></li>
//                                                         </ul>
//                                                         <div className="bot flex justify-between items-center">
//                                                             <h5 className="price">
//                                                                 COS Value: INR 5,00,000
//                                                             </h5>
//                                                             <div className="wrap-btn flex">
//                                                                 <a href="/Property-details"
//                                                                     className="tf-btn style-border pd-4">Details</a>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="box-house hover-img">
//                                                     <div className="image-wrap">
//                                                         <img className="lazyload" data-src={boxhouse3}
//                                                             src={boxhouse3} alt="" />
//                                                         <ul className="box-tag flex gap-8 ">
//                                                             <li className="flat-tag text-4 bg-main fw-6 text-white">Featured
//                                                             </li>
//                                                             <li className="flat-tag text-4 bg-3 fw-6 text-white">For Sale</li>
//                                                         </ul>
//                                                         <div className="list-btn flex gap-8 ">
//                                                             <span className="btn-icon save hover-tooltip"><i
//                                                                 className="icon-save"></i>
//                                                                 <span className="tooltip">Add Favorite</span>
//                                                             </span>
//                                                             <span className="btn-icon find hover-tooltip"><i
//                                                                 className="icon-find-plus"></i>
//                                                                 <span className="tooltip">Quick View</span>
//                                                             </span>
//                                                         </div>
//                                                     </div>
//                                                     <div className="content">
//                                                         <h5 className="title">
//                                                             <span>Elegant studio flat</span>
//                                                         </h5>
//                                                         <p className="location text-1 line-clamp-1 ">
//                                                             <i className="icon-location"></i> Medavakkam, Chennai - 600100
//                                                         </p>
//                                                         <ul className="meta-list flex cos-custom">
//                                                             <li className="meta-item"><div className="text-9 flex">Property Type</div><div className="text-9 flex"><span>Plot Land</span></div></li>
//                                                             <li className="meta-item"><div className="text-9 flex">Property Size</div><div className="text-9 flex"><span>2400 Sq.ft</span></div></li>
//                                                         </ul>
//                                                         <div className="bot flex justify-between items-center">
//                                                             <h5 className="price">
//                                                                 COS Value: INR 5,00,000
//                                                             </h5>
//                                                             <div className="wrap-btn flex">
//                                                                 <a href="/Property-details"
//                                                                     className="tf-btn style-border pd-4">Details</a>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="box-house hover-img">
//                                                     <div className="image-wrap">

//                                                         <img className="lazyload" data-src={boxhouse4}
//                                                             src={boxhouse4} alt="" />

//                                                         <ul className="box-tag flex gap-8 ">
//                                                             <li className="flat-tag text-4 bg-main fw-6 text-white">Featured
//                                                             </li>
//                                                             <li className="flat-tag text-4 bg-3 fw-6 text-white">For Sale</li>
//                                                         </ul>
//                                                         <div className="list-btn flex gap-8 ">
//                                                             <span className="btn-icon save hover-tooltip"><i
//                                                                 className="icon-save"></i>
//                                                                 <span className="tooltip">Add Favorite</span>
//                                                             </span>
//                                                             <span className="btn-icon find hover-tooltip"><i
//                                                                 className="icon-find-plus"></i>
//                                                                 <span className="tooltip">Quick View</span>
//                                                             </span>
//                                                         </div>
//                                                     </div>
//                                                     <div className="content">
//                                                         <h5 className="title">
//                                                             <span>Elegant studio flat</span>

//                                                         </h5>
//                                                         <p className="location text-1 line-clamp-1 ">
//                                                             <i className="icon-location"></i> Medavakkam, Chennai - 600100
//                                                         </p>
//                                                         <ul className="meta-list flex cos-custom">
//                                                             <li className="meta-item"><div className="text-9 flex">Property Type</div><div className="text-9 flex"><span>Plot Land</span></div></li>
//                                                             <li className="meta-item"><div className="text-9 flex">Property Size</div><div className="text-9 flex"><span>2400 Sq.ft</span></div></li>
//                                                         </ul>
//                                                         <div className="bot flex justify-between items-center">
//                                                             <h5 className="price">
//                                                                 COS Value: INR 5,00,000
//                                                             </h5>
//                                                             <div className="wrap-btn flex">
//                                                                 <a href="/Property-details"
//                                                                     className="tf-btn style-border pd-4">Details</a>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="box-house hover-img">
//                                                     <div className="image-wrap">

//                                                         <img className="lazyload" data-src={boxhouse5}
//                                                             src={boxhouse5} alt="" />

//                                                         <ul className="box-tag flex gap-8 ">
//                                                             <li className="flat-tag text-4 bg-main fw-6 text-white">Featured
//                                                             </li>
//                                                             <li className="flat-tag text-4 bg-3 fw-6 text-white">For Sale</li>
//                                                         </ul>
//                                                         <div className="list-btn flex gap-8 ">
//                                                             <span className="btn-icon save hover-tooltip"><i
//                                                                 className="icon-save"></i>
//                                                                 <span className="tooltip">Add Favorite</span>
//                                                             </span>
//                                                             <span className="btn-icon find hover-tooltip"><i
//                                                                 className="icon-find-plus"></i>
//                                                                 <span className="tooltip">Quick View</span>
//                                                             </span>
//                                                         </div>
//                                                     </div>
//                                                     <div className="content">
//                                                         <h5 className="title">
//                                                             <span>Elegant studio flat</span>

//                                                         </h5>
//                                                         <p className="location text-1 line-clamp-1 ">
//                                                             <i className="icon-location"></i> Medavakkam, Chennai - 600100
//                                                         </p>
//                                                         <ul className="meta-list flex cos-custom">
//                                                             <li className="meta-item"><div className="text-9 flex">Property Type</div><div className="text-9 flex"><span>Plot Land</span></div></li>
//                                                             <li className="meta-item"><div className="text-9 flex">Property Size</div><div className="text-9 flex"><span>2400 Sq.ft</span></div></li>
//                                                         </ul>
//                                                         <div className="bot flex justify-between items-center">
//                                                             <h5 className="price">
//                                                                 COS Value: INR 5,00,000
//                                                             </h5>
//                                                             <div className="wrap-btn flex">

//                                                                 <a href="/Property-details"
//                                                                     className="tf-btn style-border pd-4">Details</a>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="box-house hover-img">
//                                                     <div className="image-wrap">
//                                                         <img className="lazyload" data-src={boxhouse6}
//                                                             src={boxhouse6} alt="" />
//                                                         <ul className="box-tag flex gap-8 ">
//                                                             <li className="flat-tag text-4 bg-main fw-6 text-white">Featured
//                                                             </li>
//                                                             <li className="flat-tag text-4 bg-3 fw-6 text-white">For Sale</li>
//                                                         </ul>
//                                                         <div className="list-btn flex gap-8 ">
//                                                             <span className="btn-icon save hover-tooltip"><i
//                                                                 className="icon-save"></i>
//                                                                 <span className="tooltip">Add Favorite</span>
//                                                             </span>
//                                                             <span className="btn-icon find hover-tooltip"><i
//                                                                 className="icon-find-plus"></i>
//                                                                 <span className="tooltip">Quick View</span>
//                                                             </span>
//                                                         </div>
//                                                     </div>
//                                                     <div className="content">
//                                                         <h5 className="title">
//                                                             <span>Elegant studio flat</span>

//                                                         </h5>
//                                                         <p className="location text-1 line-clamp-1 ">
//                                                             <i className="icon-location"></i> Medavakkam, Chennai - 600100
//                                                         </p>
//                                                         <ul className="meta-list flex cos-custom">
//                                                             <li className="meta-item"><div className="text-9 flex">Property Type</div><div className="text-9 flex"><span>Plot Land</span></div></li>
//                                                             <li className="meta-item"><div className="text-9 flex">Property Size</div><div className="text-9 flex"><span>2400 Sq.ft</span></div></li>
//                                                         </ul>
//                                                         <div className="bot flex justify-between items-center">
//                                                             <h5 className="price">
//                                                                 COS Value: INR 5,00,000
//                                                             </h5>
//                                                             <div className="wrap-btn flex">

//                                                                 <a href="/Property-details"
//                                                                     className="tf-btn style-border pd-4">Details</a>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>

//                                             </div>
//                                         </div>
//                                     </div>
//                                 )}
//                                 {activeTab === 'list' && (
//                                     <div id="listLayout" className="tab-pane active">
//                                         <div className="tab-paneactive show " id="listLayout" role="tabpanel">
//                                             <div className="tf-grid-layout lg-col-2">
//                                                 <div className="box-house style-list hover-img">
//                                                     <div className="image-wrap">
//                                                         <span>
//                                                             <img className="lazyload" data-src={boxhouse}
//                                                                 src={boxhouse} alt="" />
//                                                         </span>
//                                                         <ul className="box-tag flex gap-8 ">
//                                                             <li className="flat-tag text-4 bg-main fw-6 text-white">Featured
//                                                             </li>
//                                                             <li className="flat-tag text-4 bg-3 fw-6 text-white">For Sale</li>
//                                                         </ul>
//                                                         <div className="list-btn flex gap-8 ">
//                                                             <span className="btn-icon save hover-tooltip"><i
//                                                                 className="icon-save"></i>
//                                                                 <span className="tooltip">Add Favorite</span>
//                                                             </span>
//                                                             <span className="btn-icon find hover-tooltip"><i
//                                                                 className="icon-find-plus"></i>
//                                                                 <span className="tooltip">Quick View</span>
//                                                             </span>
//                                                         </div>
//                                                     </div>
//                                                     <div className="content">
//                                                         <h5 className="title">
//                                                             <span>Elegant studio flat</span>
//                                                         </h5>
//                                                         <p className="location text-1 line-clamp-1 ">
//                                                             <i className="icon-location"></i> Medavakkam, Chennai - 600100
//                                                         </p>
//                                                         <ul className="meta-list flex cos-custom">
//                                                             <li className="meta-item"><div className="text-9 flex">Property Type</div><div className="text-9 flex"><span>Plot Land</span></div></li>
//                                                             <li className="meta-item"><div className="text-9 flex">Property Size</div><div className="text-9 flex"><span>2400 Sq.ft</span></div></li>
//                                                         </ul>
//                                                         <div className="bot flex justify-between items-center">
//                                                             <h5 className="price">
//                                                                 COS Value: INR 5,00,000
//                                                             </h5>
//                                                             <div className="wrap-btn flex">

//                                                                 <a href="/Property-details"
//                                                                     className="tf-btn style-border pd-4">Details</a>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="box-house style-list hover-img">
//                                                     <div className="image-wrap">
//                                                         <span>
//                                                             <img className="lazyload" data-src={boxhouse2}
//                                                                 src={boxhouse2} alt="" />
//                                                         </span>
//                                                         <ul className="box-tag flex gap-8 ">
//                                                             <li className="flat-tag text-4 bg-main fw-6 text-white">Featured
//                                                             </li>
//                                                             <li className="flat-tag text-4 bg-3 fw-6 text-white">For Sale</li>
//                                                         </ul>
//                                                         <div className="list-btn flex gap-8 ">
//                                                             <span className="btn-icon save hover-tooltip"><i
//                                                                 className="icon-save"></i>
//                                                                 <span className="tooltip">Add Favorite</span>
//                                                             </span>
//                                                             <span className="btn-icon find hover-tooltip"><i
//                                                                 className="icon-find-plus"></i>
//                                                                 <span className="tooltip">Quick View</span>
//                                                             </span>
//                                                         </div>
//                                                     </div>
//                                                     <div className="content">
//                                                         <h5 className="title">
//                                                             <span>Elegant studio flat</span>
//                                                         </h5>
//                                                         <p className="location text-1 line-clamp-1 ">
//                                                             <i className="icon-location"></i> Medavakkam, Chennai - 600100
//                                                         </p>
//                                                         <ul className="meta-list flex cos-custom">
//                                                             <li className="meta-item"><div className="text-9 flex">Property Type</div><div className="text-9 flex"><span>Plot Land</span></div></li>
//                                                             <li className="meta-item"><div className="text-9 flex">Property Size</div><div className="text-9 flex"><span>2400 Sq.ft</span></div></li>
//                                                         </ul>
//                                                         <div className="bot flex justify-between items-center">
//                                                             <h5 className="price">
//                                                                 COS Value: INR 5,00,000
//                                                             </h5>
//                                                             <div className="wrap-btn flex">

//                                                                 <a href="/Property-details"
//                                                                     className="tf-btn style-border pd-4">Details</a>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="box-house style-list hover-img">
//                                                     <div className="image-wrap">
//                                                         <span>
//                                                             <img className="lazyload" data-src={boxhouse3}
//                                                                 src={boxhouse3} alt="" />
//                                                         </span>
//                                                         <ul className="box-tag flex gap-8 ">
//                                                             <li className="flat-tag text-4 bg-main fw-6 text-white">Featured
//                                                             </li>
//                                                             <li className="flat-tag text-4 bg-3 fw-6 text-white">For Sale</li>
//                                                         </ul>
//                                                         <div className="list-btn flex gap-8 ">
//                                                             <span className="btn-icon save hover-tooltip"><i
//                                                                 className="icon-save"></i>
//                                                                 <span className="tooltip">Add Favorite</span>
//                                                             </span>
//                                                             <span className="btn-icon find hover-tooltip"><i
//                                                                 className="icon-find-plus"></i>
//                                                                 <span className="tooltip">Quick View</span>
//                                                             </span>
//                                                         </div>
//                                                     </div>
//                                                     <div className="content">
//                                                         <h5 className="title">
//                                                             <span>Elegant studio flat</span>
//                                                         </h5>
//                                                         <p className="location text-1 line-clamp-1 ">
//                                                             <i className="icon-location"></i> Medavakkam, Chennai - 600100
//                                                         </p>
//                                                         <ul className="meta-list flex cos-custom">
//                                                             <li className="meta-item"><div className="text-9 flex">Property Type</div><div className="text-9 flex"><span>Plot Land</span></div></li>
//                                                             <li className="meta-item"><div className="text-9 flex">Property Size</div><div className="text-9 flex"><span>2400 Sq.ft</span></div></li>
//                                                         </ul>
//                                                         <div className="bot flex justify-between items-center">
//                                                             <h5 className="price">
//                                                                 COS Value: INR 5,00,000
//                                                             </h5>
//                                                             <div className="wrap-btn flex">

//                                                                 <a href="/Property-details"
//                                                                     className="tf-btn style-border pd-4">Details</a>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="box-house style-list hover-img">
//                                                     <div className="image-wrap">
//                                                         <span>
//                                                             <img className="lazyload" data-src={boxhouse4}
//                                                                 src={boxhouse4} alt="" />
//                                                         </span>
//                                                         <ul className="box-tag flex gap-8 ">
//                                                             <li className="flat-tag text-4 bg-main fw-6 text-white">Featured
//                                                             </li>
//                                                             <li className="flat-tag text-4 bg-3 fw-6 text-white">For Sale</li>
//                                                         </ul>
//                                                         <div className="list-btn flex gap-8 ">
//                                                             <span className="btn-icon save hover-tooltip"><i
//                                                                 className="icon-save"></i>
//                                                                 <span className="tooltip">Add Favorite</span>
//                                                             </span>
//                                                             <span className="btn-icon find hover-tooltip"><i
//                                                                 className="icon-find-plus"></i>
//                                                                 <span className="tooltip">Quick View</span>
//                                                             </span>
//                                                         </div>
//                                                     </div>
//                                                     <div className="content">
//                                                         <h5 className="title">
//                                                             <span>Elegant studio flat</span>
//                                                         </h5>
//                                                         <p className="location text-1 line-clamp-1 ">
//                                                             <i className="icon-location"></i> Medavakkam, Chennai - 600100
//                                                         </p>
//                                                         <ul className="meta-list flex cos-custom">
//                                                             <li className="meta-item"><div className="text-9 flex">Property Type</div><div className="text-9 flex"><span>Plot Land</span></div></li>
//                                                             <li className="meta-item"><div className="text-9 flex">Property Size</div><div className="text-9 flex"><span>2400 Sq.ft</span></div></li>
//                                                         </ul>
//                                                         <div className="bot flex justify-between items-center">
//                                                             <h5 className="price">
//                                                                 COS Value: INR 5,00,000
//                                                             </h5>
//                                                             <div className="wrap-btn flex">

//                                                                 <a href="/Property-details"
//                                                                     className="tf-btn style-border pd-4">Details</a>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="box-house style-list hover-img">
//                                                     <div className="image-wrap">
//                                                         <span>
//                                                             <img className="lazyload" data-src={boxhouse5}
//                                                                 src={boxhouse5} alt="" />
//                                                         </span>
//                                                         <ul className="box-tag flex gap-8 ">
//                                                             <li className="flat-tag text-4 bg-main fw-6 text-white">Featured
//                                                             </li>
//                                                             <li className="flat-tag text-4 bg-3 fw-6 text-white">For Sale</li>
//                                                         </ul>
//                                                         <div className="list-btn flex gap-8 ">
//                                                             <span className="btn-icon save hover-tooltip"><i
//                                                                 className="icon-save"></i>
//                                                                 <span className="tooltip">Add Favorite</span>
//                                                             </span>
//                                                             <span className="btn-icon find hover-tooltip"><i
//                                                                 className="icon-find-plus"></i>
//                                                                 <span className="tooltip">Quick View</span>
//                                                             </span>
//                                                         </div>
//                                                     </div>
//                                                     <div className="content">
//                                                         <h5 className="title">
//                                                             <span>Elegant studio flat</span>
//                                                         </h5>
//                                                         <p className="location text-1 line-clamp-1 ">
//                                                             <i className="icon-location"></i> Medavakkam, Chennai - 600100
//                                                         </p>
//                                                         <ul className="meta-list flex cos-custom">
//                                                             <li className="meta-item"><div className="text-9 flex">Property Type</div><div className="text-9 flex"><span>Plot Land</span></div></li>
//                                                             <li className="meta-item"><div className="text-9 flex">Property Size</div><div className="text-9 flex"><span>2400 Sq.ft</span></div></li>
//                                                         </ul>
//                                                         <div className="bot flex justify-between items-center">
//                                                             <h5 className="price">
//                                                                 COS Value: INR 5,00,000
//                                                             </h5>
//                                                             <div className="wrap-btn flex">

//                                                                 <a href="/Property-details"
//                                                                     className="tf-btn style-border pd-4">Details</a>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="box-house style-list hover-img">
//                                                     <div className="image-wrap">
//                                                         <span>
//                                                             <img className="lazyload" data-src={boxhouse6}
//                                                                 src={boxhouse6} alt="" />
//                                                         </span>
//                                                         <ul className="box-tag flex gap-8 ">
//                                                             <li className="flat-tag text-4 bg-main fw-6 text-white">Featured
//                                                             </li>
//                                                             <li className="flat-tag text-4 bg-3 fw-6 text-white">For Sale</li>
//                                                         </ul>
//                                                         <div className="list-btn flex gap-8 ">
//                                                             <span className="btn-icon save hover-tooltip"><i
//                                                                 className="icon-save"></i>
//                                                                 <span className="tooltip">Add Favorite</span>
//                                                             </span>
//                                                             <span className="btn-icon find hover-tooltip"><i
//                                                                 className="icon-find-plus"></i>
//                                                                 <span className="tooltip">Quick View</span>
//                                                             </span>
//                                                         </div>
//                                                     </div>
//                                                     <div className="content">
//                                                         <h5 className="title">
//                                                             <span>Elegant studio flat</span>
//                                                         </h5>
//                                                         <p className="location text-1 line-clamp-1 ">
//                                                             <i className="icon-location"></i> Medavakkam, Chennai - 600100
//                                                         </p>
//                                                         <ul className="meta-list flex cos-custom">
//                                                             <li className="meta-item"><div className="text-9 flex">Property Type</div><div className="text-9 flex"><span>Plot Land</span></div></li>
//                                                             <li className="meta-item"><div className="text-9 flex">Property Size</div><div className="text-9 flex"><span>2400 Sq.ft</span></div></li>
//                                                         </ul>
//                                                         <div className="bot flex justify-between items-center">
//                                                             <h5 className="price">
//                                                                 COS Value: INR 5,00,000
//                                                             </h5>
//                                                             <div className="wrap-btn flex">

//                                                                 <a href="/Property-details"
//                                                                     className="tf-btn style-border pd-4">Details</a>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>

//                                             </div>
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                             <div className="wrap-pagination">
//                                 <p className="text-1">Showing 1-8 of 42 results.</p>
//                                 <ul className="wg-pagination ">
//                                     <li className="arrow">
//                                         <span><i className="icon-arrow-left"></i></span>
//                                     </li>
//                                     <li>
//                                         <span>1</span>
//                                     </li>
//                                     <li className="active">
//                                         <span>2</span>
//                                     </li>
//                                     <li>
//                                         <span>...</span>
//                                     </li>
//                                     <li>
//                                         <span>20</span>
//                                     </li>
//                                     <li className="arrow">
//                                         <span><i className="icon-arrow-right"></i></span>
//                                     </li>
//                                 </ul>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         </div>
//     );
// };

// export default TopsearchCards;
